//Favicons
export const USFavicon = "https://images-wcs.s3-us-west-2.amazonaws.com/New-Western-Container-Sales-Favicon-Logo-Shipping-Containers-For-Sale-Conex-Box-Rent-Storage-Container-514px-square.png";
export const CAFavicon = "https://images-ncs.s3-us-west-2.amazonaws.com/favicon.ico";

//Shopify_Storefront_URL
export const USAShopifyStorefrontUrl = "https://railbox-consulting.myshopify.com/api/graphql";
export const CanadaShopifyStorefrontUrl = "https://northern-container-sales.myshopify.com/api/graphql";

//Shopify_Storefront_Token
export const USAStorefrontAccessToken = "56cb73c2f6c2f28d28c6adca55809a3e";
export const CanadaStorefrontAccessToken = "7a6db3e0cecae3c5095fc5d5b23a9c92";

//ShopifyStore_domain
export const USAShopifyDomain = "buy.westerncontainersales.com";
export const CanadaShopifyDomain = "northerncontainer.ca";

//Sample Photos Links
export const USASamplePhotos = "https://westerncontainersales.com/sample-pics/";
export const CanadaSamplePhotos = "https://northerncontainersales.ca/more-info/sample-photos/";

//CSC Survey Links
export const USACSCSurveyLink = "https://westerncontainersales.com/buy-shipping-containers-online/csc-marine-survey/";
export const CanadaCSCSurveyLink = "https://northerncontainersales.ca/buy-shipping-containers/csc-survey/";

//Space For Truck Message Link
export const USASpaceTruckLink = "https://westerncontainersales.com/buy-shipping-containers-online/delivery/";
export const CanadaSpaceTruckLink = "https://northerncontainersales.ca/more-info/about-delivery/";